import React, { useContext, useEffect } from 'react';
import CartLine from '../components/CartLine';
import { Link, useNavigate } from 'react-router-dom';
import { CartContext } from '../context/CartContext';
import { UserContext } from '../context/UserContext';
import * as Icon from 'react-bootstrap-icons';

const Cart = () => {

    const auth = useContext(UserContext);
    const { cart, removeFromCart, updateQuantity, addToCart } = useContext(CartContext);
    const navigate = useNavigate();

    const handleQuantityChange = (productId, quantity) => {
        if (quantity > 0) {
            updateQuantity(productId, quantity);
        }
    };

    // Calculate total, GST, and shipping
    const total = cart.reduce((sum, item) => sum + item.product.update_price * item.quantity, 0);

    const totalGST = cart.reduce((sum, item) => sum + (item.product.gst / 100) * (item.product.update_price * item.quantity), 0);
    const shipping = total > 500 ? 0 : 50;
    const totalWithShipping = parseFloat((total + totalGST + shipping).toFixed(2));

    useEffect(() => {
        const token = localStorage.getItem('token');
        if (!token) {
            navigate('/login');
        }
    }, [navigate]);

    return (
        <div className='mt-5 pt-4'>
            <Link to="/" className='mt-2 btn btn-success ms-3'>
                <Icon.ArrowLeft className='me-2 fw-bold' />
            </Link>

            <div className='container p-3 page-section'>
                <div className='row p-4'>
                    <div className="col-lg-8 minHight">
                        <div className="row">
                            {cart.length > 0 ? (
                                cart.map((item, i) => (
                                    <div key={i} className="col-12 mb-3">
                                        <CartLine
                                            product={item}
                                            handleQuantityChange={handleQuantityChange}
                                            removeFromCart={removeFromCart}
                                            addToCart={addToCart}
                                            total={total}
                                        />
                                    </div>
                                ))
                            ) : (
                                <div className='text-center pt-3'>
                                    <h1 className='text-muted fw-bold mt-5'>Cart is empty</h1>
                                    <Link to="/" className='mt-3 btn btn-success'>
                                        <Icon.ArrowLeft className='me-2' />Continue Shopping
                                    </Link>
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="col-lg-4">
                        {auth.user != null && (
                            <div className="card p-3 rounded">
                                <h4 className='text-dark fw-semibold mb-3 fs-5 d-flex justify-content-between align-content-center'>
                                    <span>Total amount:</span> <span>₹ {total.toFixed(2)}/-</span>
                                </h4>
                                <h6 className='text-muted d-flex justify-content-between align-content-center'>
                                    <span>GST/TAXES:</span> <span>₹ {totalGST.toFixed(2)}/-</span>
                                </h6>
                                <h6 className='text-muted d-flex justify-content-between align-content-center'>
                                    <span>Shipping charges:</span> <span>{total > 500.00 ? "₹ 00/-" : "₹ 50/-"}</span>
                                </h6>
                                <h3 className='mt-4 mb-4 fw-semibold fs-5 d-flex justify-content-between align-content-center py-2 border-top border-bottom'>
                                    <span>Grand total:</span> <span>₹ {parseFloat(total.toFixed(2)) > 0 ? totalWithShipping : '0.00'}/-</span>
                                </h3>
                                {cart.length > 0 && (
                                    auth.user.isActive === 2 ? (
                                        <h6 className='text-warning'>Please update your details to order!</h6>
                                    ) : auth.user.isActive === 0 ? (
                                        <h6 className='text-muted'>You are an inactive user!</h6>
                                    ) : (
                                        <Link to="/checkout" className='btn btn-success w-100 shadow-none'>Check out</Link>
                                    )
                                )}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Cart;
